window.onload = function(e){
    let fa = document.querySelectorAll('.facets__summary')
    if (fa.length !== 0){
    let fa1 = fa[1]
    let avi = document.querySelector('.facets__summary-label')
    let price = ((fa1.children)[0]).children[0]
    console.log(price)
    price.innerText = '価格'
    avi.innerText = '選択肢'      
    }
}
